import request from '@/utils/request'
import { xlsDownload } from '@/api/view/hip/common/commonXls'

export function getDelyNoList(param) {
  let data = param
  return request({
    url: `/deliveryControl/epms9020/getDelyNoList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epms9020DelyList(param) {
  let data = param
  return request({
    url: `/deliveryControl/epms9020/epms9020DelyList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epms9020PoList(param) {
  let data = param
  return request({
    url: `/deliveryControl/epms9020/epms9020PoList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epms9020Save(param) {
  let data = param
  return request({
    url: `/deliveryControl/epms9020/epms9020Save`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epms9020Delete(param) {
  let data = param
  return request({
    url: `/deliveryControl/epms9020/epms9020Delete`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epms9020Xls(param) {
  const data = param
  return request({
    url: `/deliveryControl/epms9020/epms9020Xls`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  }).then(res => {
    // console.log('epms9020XlsRes', res)

    const filename = 'Delivery Status.xls'
    xlsDownload(filename, res)
  })
}